module.exports = __webpack_public_path__ + "img/product_img01.3601dcda.png";